import { IAM, iam } from '@rhitics/core'
import Vue from 'vue'

export type AlertType = undefined | 'success' | 'info' | 'warning' | 'error'

export default Vue.extend({
  name: 'RtsPacManMixin',

  data() {
    return {
      floatButtonPos: 'top',
      isDarkMode: false,
      activeLocale: 'en'
    }
  },

  watch: {
    floatButtonPos() {
      localStorage.setItem('pac_man_kind', this.floatButtonPos)
    }
  },

  created() {
    this.floatButtonPos = localStorage.getItem('pac_man_kind') ?? 'top'
    this.isDarkMode = (localStorage.getItem('circadian_theme') ?? 'dark') === 'dark'
    this.activeLocale = localStorage.getItem('locale_preference') ?? 'en'
    this.$vuetify.theme.dark = this.isDarkMode
    this.$i18n.locale = this.activeLocale
  },

  methods: {
    updateLocale() {
      // @ts-ignore
      this.$i18n.locale = this.activeLocale
      localStorage.setItem('locale_preference', this.activeLocale)
    }
  }
})
